<template>
  <section class="contact-info">
    <div class="c-container c-container--small">
      <h2 data-anim="title">{{ data.title }}</h2>

      <div class="contact-info__content">
        <address>
          <h4 data-anim="title">Acres</h4>
          <a href="Ottieni indicazioni" target="_blank" rel="noopener" data-anim="paragraph">
            Via Veneto, 18 – 25036<br>
            Palazzolo Sull'Oglio (Bs) – Italia
          </a>
          <a href="tel:+390307300511" target="_blank" rel="noopener" data-anim="paragraph">
            <b>T:</b> +39 030 7300511
          </a>
          <p data-anim="paragraph">
            <b>F:</b> +39 030 7400852
          </p>
          <a href="mailto:info@acres-srl.it" target="_blank" rel="noopener" data-anim="paragraph">
            <b>Email:</b> info@acres-srl.it
          </a>
        </address>
        <AppFigure
          :data="{ src: data.src, alt: data.alt }"
          class="contact-info__image"
        />
      </div>
    </div>
  </section>
</template>

<script>
import AppFigure from '@/components/AppFigure.vue';

export default {
  name: 'ContactInfo',

  components: {
    AppFigure,
  },

  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../scss/utils';
@import "~sass-mq/mq";

.contact-info {
  h2 {
    margin-bottom: 60px;
  }

  &__content {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    flex-flow: row wrap;
  }

  address {
    width: 100%;
    font-style: normal;


    @include mq(ipadL) {
      width: calc(30% - 80px);
    }

    h4 {
      margin-bottom: 20px;
    }

    a {
      display: block;

      &:first-of-type {
        margin-bottom: 15px;
      }

      &:last-of-type {
        margin-top: 15px;
      }
    }

    b {
      font-family: 'Apercu';
      color: $color-red;
    }
  }

  &__image {
    width: 100%;
    margin-top: 20px;

    @include aspect-ratio(16, 7);

    @include mq(ipadL) {
      margin-top: 0;
      width: 70%;
    }
  }
}
</style>
